// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__ltI4t","notes":"Notes_notes__3RZWQ"};